export default __webpack_public_path__ + "static/media/iconesMinhasContrataçõesMaior.630f779f.png";